<template>
  <div class="titleNotify">
    <h2>Embalagens em manutenção</h2>
    <p>Modelos:</p>
  </div>
  <div
    class="listNotify"
    v-for="modelMaintenance in allNotificationMaintenance"
    :key="modelMaintenance.id"
  >
    <div class="notifyName">
      <h1>{{ modelMaintenance.descricao }}</h1>
    </div>
    <div class="notifyNumber">
      <h1>{{ modelMaintenance.count }}</h1>
    </div>
  </div>
</template>

<script>
import httpNotificationMaintenance from "../../services/Notifications";

export default {
  data() {
    return {
      allNotificationMaintenance: [],
    };
  },
  async mounted() {
    this.$store.commit("CHANGE_LOADING");  
    await httpNotificationMaintenance
      .GetNotificationMaintenance()
      .then((res) => {
        this.allNotificationMaintenance = res.data;
        this.$store.commit("CHANGE_LOADING");  
        return;
      });
  },
};
</script>

<style scoped>
.notify {
  font-size: 1.5rem;
  cursor: pointer;
}

.container_notify {
  color: var(--colorText-secondary);
  padding: 0 2vw;
}

.titleNotify {
  width: 100%;
  border-bottom: 2px solid rgba(0, 0, 0, 0.116);
}

.titleNotify h2 {
  margin-bottom: 1rem;
}

.listNotify {
  display: flex;
  justify-content: space-between;
  height: 3rem;
  align-items: center;
  border-bottom: 1px solid var(--colorFilterButton);
  padding: 0.7rem;
}

.notifyNumber {
  display: flex;
  align-items: center;
}

.notifyNumber h1 {
  color: var(--colorPrimary);
  font-size: 1.6rem;
  display: flex;
}

.notifyName h1 {
  font-size: 1rem;
  text-transform: uppercase;
}

.alertIcon {
  background: var(--notifyDelay);
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}

.alert {
  width: 2rem;
  display: flex;
  justify-content: center;
}

.menuNotify {
  background: var(--white);
  height: 100%;
  width: 0px;
  transition: 0.2s;
  z-index: 10;
  display: grid;
  align-items: center;
  position: fixed;
  right: 0;
  overflow: hidden;
}

.showNoti {
  width: 500px;
}

@media only screen and (max-width: 600px) {
  .notifyNumber h1 {
    font-size: 6.5vw;
  }

  .titleNotify h2 {
    font-size: 1.6rem;
  }

  .titleNotify p {
    font-size: 2vh;
    padding-bottom: 2px;
  }
}
</style>
